import PropTypes from 'prop-types';
// @mui
import { IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
//
import MenuPopover from '../MenuPopover';

// ----------------------------------------------------------------------

TableMoreMenu.propTypes = {
  actions: PropTypes.node,
  open: PropTypes.object,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
};

export default function TableMoreMenu({ actions, open, onClose, onOpen }) {
  const lang = localStorage.getItem('i18nextLng');
  
  return (
    <>
      <IconButton onClick={onOpen}>
        <MoreVertIcon sx={{ width: 18, height: 18 }} />
      </IconButton>
      
      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={onClose}
        anchorOrigin={{ vertical: 'top', horizontal: lang === "fa" ? 'right': 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: lang === "fa" ? 'left' : 'right' }}
        arrow="right-top"
        sx={{
          mt: -1,
          '& .MuiMenuItem-root': { 
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
            '& svg': { mr: 1, width: 18, height: 18 },
          },
        }}
      >
        {actions}
      </MenuPopover>
    </>
  );
}